export const validationMessage = {
    workspaceTitle: 'WORKSPACE.TITLE_VALIDATION_MESSAGE',
    workspaceName: 'WORKSPACE.WORKSPACE_NAME_VALIDATION_MESSAGE',
    workspaceNameInvalidCharacter: 'WORKSPACE.WORKSPACE_NAME_INVALID_CHARACTER',
    slug: 'SLUG.VALIDATION_MESSAGE'
};
